// extracted by mini-css-extract-plugin
module.exports = {"pokerChipCardHeader":"_0a9bcfe","pokerChipBackground":"_9a81c1b","container":"_df2b7ac","spadeOuter":"_b0c08eb","spadeInner":"_e87c6df","countInner":"_5728c04"};